import { Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CommunicationsGeneralConfigurationSkeleton = () => {
  return (
    <Styles.Container>
      <Styles.Section>
        <Skeleton variant="text" width={220} height={28} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />

        <Divider />

        <Skeleton variant="text" width={200} height={24} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Skeleton variant="text" width={280} height={28} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="rounded" width="100%" height={56} />

        {Array.from({ length: 4 }).map((_, index) => (
          <Styles.ToggleCommunicationCard key={index}>
            <Styles.ToggleRow>
              <Skeleton variant="rounded" width={48} height={24} />
              <Skeleton variant="text" width={240} height={20} />
            </Styles.ToggleRow>
            <Skeleton variant="text" width="80%" height={16} />
            <Skeleton variant="rounded" width="100%" height={48} />
          </Styles.ToggleCommunicationCard>
        ))}
      </Styles.Section>
    </Styles.Container>
  )
}

export default CommunicationsGeneralConfigurationSkeleton
